import { HotToastService } from "@ngneat/hot-toast";
import { JobTimeTrackingService } from "../job-time-tracking-modal/job-time-tracking.service";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { TimeTracking } from "../models/models";
import { BsModalRef } from "ngx-bootstrap/modal";
import { FormsModule } from "@angular/forms";
import { DatePickerModule } from "primeng/datepicker";
import { NgIf, NgFor, NgClass, DatePipe } from "@angular/common";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";
@Component({
  selector: "app-time-tracking-details-modal",
  templateUrl: "./time-tracking-details-modal.component.html",
  styleUrls: ["./time-tracking-details-modal.component.scss"],
  imports: [NgIf, NgFor, NgClass, DatePickerModule, FormsModule, DatePipe, EmptyStateComponent],
})
export class TimeTrackingDetailsModalComponent implements OnInit {
  @Input() timeTrackingInfo;
  @Input() jobUuid: string;
  numberOfEntries: number;
  sumOfTimesTracked;
  selectedTimeTracking = null;
  testingPCalendar;
  isAddingNewEntry: boolean = false;

  constructor(
    public jobsTimeTrackingService: JobTimeTrackingService,
    public bsModalRef: BsModalRef,
    private toastr: HotToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    console.log(this.timeTrackingInfo);
    this.numberOfEntries = this.timeTrackingInfo.length;

    this.sumOfTimesTracked = this.timeTrackingInfo.reduce((prev, curr) => {
      return prev + curr.time_tracked;
    }, 0);
  }

  updateTimeTracked(timeTracked) {
    const timeString = timeTracked.replace(/[^\d:]/g, "");
    console.log("timestring", timeString);
    let [hours, minutes, seconds] = timeString.split(":").map(Number);

    if (!seconds) {
      seconds = 0;
    }

    if (!minutes) {
      minutes = 0;
    }

    if (hours != 0) {
      let stringHours = hours.toString();
      if (stringHours.length > 2) {
        stringHours = stringHours[0] + stringHours[1];
        hours = +stringHours;
      }
    }
    if (minutes != 0) {
      let stringHours = minutes.toString();
      if (stringHours.length > 2) {
        stringHours = stringHours[0] + stringHours[1];
        minutes = +stringHours;
      }
    }
    if (seconds != 0) {
      let stringHours = seconds.toString();
      if (stringHours.length > 2) {
        stringHours = stringHours[0] + stringHours[1];
        seconds = +stringHours;
      }
    }
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    this.selectedTimeTracking.time_tracked = totalSeconds;
  }

  updateTimeTracking() {
    this.selectedTimeTracking = {
      ...this.selectedTimeTracking,
      start_date: this.selectedTimeTracking.start_date.toISOString(),
      completed_date: this.selectedTimeTracking.completed_date.toISOString(),
    };
    this.jobsTimeTrackingService
      .updateTimeTracking(this.selectedTimeTracking)
      .then((data: { time_tracking: TimeTracking }) => {
        this.timeTrackingInfo = this.timeTrackingInfo.map((entry) =>
          entry.id === data.time_tracking.id ? data.time_tracking : entry,
        );
        this.sumOfTimesTracked = this.timeTrackingInfo.reduce((prev, curr) => {
          return prev + curr.time_tracked;
        }, 0);
        this.jobsTimeTrackingService.updateTotalTimeTracked.next(
          this.jobsTimeTrackingService.timeTrackedFormatter(
            this.sumOfTimesTracked,
          ),
        );
        this.cdr.detectChanges();
        this.selectedTimeTracking = null;
        this.toastr.success("Time tracking updated successfully!");
      });
  }

  /*
    This function makes the enter key
    to behave like a tab press when
    the focused element is jobName;
  */
  updateTimeTrackedEnter(ev) {
    if (ev.keyCode == 13) {
      ev.preventDefault();
      document.getElementById("editable-time").blur();
    }
  }

  selectTimeTracking(timeTracking) {
    if (
      this.selectedTimeTracking &&
      this.selectedTimeTracking.id === timeTracking.id
    )
      this.selectedTimeTracking = null;
    else {
      this.selectedTimeTracking = {
        ...timeTracking,
        start_date: new Date(timeTracking.start_date),
        completed_date: new Date(timeTracking.completed_date),
      };
    }
  }

  showNewEntry() {
    this.selectedTimeTracking = {
      notes: "",
      time_tracked: 0,
      start_date: new Date(),
    };
    this.isAddingNewEntry = true;
  }

  hideAddNewEntry() {
    this.selectedTimeTracking = null;
    this.isAddingNewEntry = false;
    this.cdr.detectChanges();
  }

  addNewEntry() {
    const currentDate = new Date();
    const completedDate = new Date(
      currentDate.getTime() + this.selectedTimeTracking.time_tracked * 1000,
    );
    this.selectedTimeTracking = {
      ...this.selectedTimeTracking,
      start_date: this.selectedTimeTracking.start_date.toISOString(),
      completed_date: completedDate.toISOString(),
      type: "client_work",
    };

    this.jobsTimeTrackingService
      .addNewEntryFromDetails(this.jobUuid, this.selectedTimeTracking)
      .then((response: any) => {
        this.timeTrackingInfo.push(response.time_tracking);
        this.sumOfTimesTracked = this.timeTrackingInfo.reduce((prev, curr) => {
          return prev + curr.time_tracked;
        }, 0);
        this.jobsTimeTrackingService.updateTotalTimeTracked.next(
          this.jobsTimeTrackingService.timeTrackedFormatter(
            this.sumOfTimesTracked,
          ),
        );
        this.toastr.success(response.message);
      })
      .catch((error) => {
        console.log(error);
        this.toastr.error(error.message);
      })
      .finally(() => this.hideAddNewEntry());
    this.cdr.detectChanges();

  }
}
